type IExtractTrueFlags<
    T extends Record<string, unknown>,
    K extends readonly string[],
    U extends K[number] & keyof T,
> = {
    trueKeysArr: U[];
    restObj: Omit<T, U>;
};

export function extractTrueFlags<
    T extends Record<string, unknown>,
    K extends readonly string[],
    U extends K[number] & keyof T,
>(obj: T, keys: K): IExtractTrueFlags<T, K, U> {
    const trueKeysArr: U[] = [];
    const restObj: Omit<T, U> = { ...obj } as Omit<T, U>;

    (keys as unknown as readonly U[]).forEach((key) => {
        const val: T[U] = obj[key];
        if (val === true) {
            trueKeysArr.push(key);
        }
        delete (restObj as any)[key];
    });
    return { trueKeysArr, restObj };
}
